import {MenuItem} from '@/store/types';
import {RouteConfig} from 'vue-router';
import AppRouterComponent from '@/modules/app-router/components/AppRouterComponent.vue'
import PresenceControl from '@/modules/app-router/components/PresenceControl.vue'
import VersionsForGroups from '@/modules/app-router/components/AppRelease/VersionsForGroups.vue'
import EventLog from '@/modules/app-router/components/AppRelease/EventLog.vue'
import LogDetail from '@/modules/app-router/components/AppRelease/LogDetail.vue'
import UnigestFastLogin from '@/modules/app-router/components/UnigestFastLogin.vue';

export function menu (): MenuItem[] {
    return [
        {
            title: 'Enrutador de aplicaciones',
            icon: 'mdi-arrow-decision-outline',
            routeName: 'app-router',
            requireAuthorization: false,
        },
    ]
}

export function routes (): RouteConfig[] {
    return [
        {
            name: 'app-router',
            path: '/enrutador',
            component: AppRouterComponent,
            children: [
                {
                    name: 'unigest-login',
                    path: 'unigest-login',
                    component: UnigestFastLogin,
                    meta: {
                        toolbarTitle: 'Inicio de sesión en Unigest',
                        vuex: {
                            loadModules: ['appRouter', 'user'],
                        },
                    },
                },
                {
                    name: 'versions-for-groups',
                    path: 'versiones-de-grupos',
                    component: VersionsForGroups,
                    meta: {
                        toolbarTitle: 'Versiones para grupos',
                        vuex: {
                            loadModules: ['appRouter', 'user'],
                        },
                    },
                },
            ],
            meta: {
                toolbarTitle: 'Enrutador de Aplicaciones',
                vuex: {
                    loadModules: ['appRouter', 'user'],
                },
            },
        },
        {
            name: 'app-router-logs',
            path: '/enrutador/logs',
            component: EventLog,
            children: [
                {
                    name: 'log-detail',
                    path: ':id',
                    component: LogDetail,
                    meta: {
                        vuex: {
                            loadModules: ['appRouter', 'user'],
                        },
                    },
                },
            ],
            meta: {
                toolbarTitle: 'Registro de eventos',
                vuex: {
                    loadModules: ['appRouter', 'user'],
                },
            },
        },
        {
            name: 'presence-control',
            path: '/enrutador/control-de-presencia',
            component: PresenceControl,
            meta: {
                toolbarTitle: 'Control de presencia',
                vuex: {
                    loadModules: ['appRouter', 'user'],
                },
            },
        },
    ]
}
